export default __webpack_public_path__ + "static/media/thumbnail-7.2eb8199e.jpg";